import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function thankYouDataFromQuery(query) {
  const {
    minStartDate,
    maxStartDate,
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    verticalStatusContent,
    biOptions
  } = integrationDataFromQuery(query);
  const orderId = query.get('orderId');
  if (!orderId) {
    throw new MissingRequiredParameterError('orderId');
  }
  return {
    successful: true,
    ownerDemo: query.get('ownerDemo') === 'true',
    orderId,
    planId: undefined,
    minStartDate,
    maxStartDate,
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    verticalStatusContent,
    biOptions
  };
}
export function thankYouDataToQuery(data) {
  const query = commonIntegrationDataToQuery(data.purchaseData.checkoutData.integrationData);
  query.set('orderId', data.purchaseData.orderId);
  data.ownerDemo && query.set('ownerDemo', 'true');
  return query;
}
//# sourceMappingURL=thank-you-data.js.map